module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0132.jpg?v=24444ca6";